import { render } from "./RecipeIngredients.vue?vue&type=template&id=9403f66c&scoped=true"
import script from "./RecipeIngredients.vue?vue&type=script&lang=js"
export * from "./RecipeIngredients.vue?vue&type=script&lang=js"

import "./RecipeIngredients.vue?vue&type=style&index=0&id=9403f66c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9403f66c"]])

export default __exports__